export const urlQueryParamsCreator = (input: Record<string, any>) => {
  if (typeof input !== 'object') return null
  const urlSearchParams = new URLSearchParams()
  for (let field in input) {
    if (Object.hasOwn(input, field)) {
      const value = input[field]
      const isValid = typeof value === 'string' || typeof value === 'number'
      if (isValid) value && urlSearchParams.append(field, String(value))
    }
  }
  const params = `${urlSearchParams}`
  return params ? `?${params}` : ''
}
